import React from 'react';
import cl from '../Stub.module.css';
import usePageMeta from '../../hooks/usePageMeta';

// Политика обработки персональных данных. Базовый текст 152-ФЗ.
// После запуска прода рекомендуется прогнать через юриста.
export default function Privacy() {
    usePageMeta({
        title: 'Политика конфиденциальности · СтартКласс',
        description: 'Политика обработки персональных данных пользователей сервиса СтартКласс.',
        canonical: 'https://startklass.ru/privacy',
    });
    return (
        <main className={cl.page} style={{ maxWidth: 820, textAlign: 'left' }}>
            <span className={cl.eyebrow}>Юридическое</span>
            <h1 className={cl.title} style={{ textAlign: 'left' }}>
                Политика обработки персональных данных
            </h1>
            <p className={cl.text} style={{ textAlign: 'left' }}>
                Действует с 11 мая 2026 г. Редакция 1.0.
            </p>

            <h2 style={H2}>1. Общие положения</h2>
            <p style={P}>
                Настоящая Политика определяет порядок обработки персональных данных
                посетителями сайта <b>startklass.ru</b> (далее — Сайт) и лицами,
                регистрирующими личный кабинет руководителя детского образовательного
                центра.
            </p>
            <p style={P}>
                Оператором персональных данных является <b>ИП Иванкова Виктория Сергеевна</b>,
                ОГРНИП 322237500039230, ИНН 233507286445, адрес: Краснодарский край,
                г. Кореновск, ул. Мира 93 (далее — Оператор).
            </p>
            <p style={P}>
                Политика разработана в соответствии с Федеральным законом от 27.07.2006
                №152-ФЗ «О персональных данных».
            </p>

            <h2 style={H2}>2. Какие данные мы обрабатываем</h2>
            <ul style={UL}>
                <li>Имя контактного лица</li>
                <li>Адрес электронной почты</li>
                <li>Номер телефона (если указан)</li>
                <li>Название детского центра, город, юридическая форма (ИП/ООО), ИНН</li>
                <li>Технические данные: IP-адрес, идентификатор сессии, тип браузера,
                    дата и время визита</li>
            </ul>

            <h2 style={H2}>3. Цели обработки</h2>
            <ul style={UL}>
                <li>Создание и ведение личного кабинета пользователя</li>
                <li>Предоставление демо-доступа к образовательной платформе</li>
                <li>Выставление счетов на оплату подписки и оформление договоров</li>
                <li>Информирование о статусе подписки, обновлениях, технических работах</li>
                <li>Обработка обращений в техподдержку и обратных звонков</li>
                <li>Защита от автоматизированных атак (антиспам, антифрод)</li>
            </ul>

            <h2 style={H2}>4. Правовое основание</h2>
            <p style={P}>
                Обработка осуществляется на основании согласия субъекта персональных
                данных, которое предоставляется при регистрации, а также для исполнения
                договора, стороной которого является субъект (публичная оферта).
            </p>

            <h2 style={H2}>5. Сроки и условия хранения</h2>
            <p style={P}>
                Персональные данные хранятся до прекращения действия согласия либо до
                момента удаления учётной записи пользователем. Данные о платежах и
                выставленных счетах хранятся не менее 5 лет в соответствии с
                требованиями налогового законодательства РФ.
            </p>

            <h2 style={H2}>6. Передача третьим лицам</h2>
            <p style={P}>
                Персональные данные не передаются третьим лицам, за исключением:
                АО «ТБанк» (в рамках обработки платежей при их подключении),
                хостинг-провайдеров и уполномоченных государственных органов в
                случаях, предусмотренных законодательством РФ.
            </p>

            <h2 style={H2}>7. Права субъекта</h2>
            <p style={P}>Пользователь вправе:</p>
            <ul style={UL}>
                <li>Получать информацию о том, какие его данные обрабатываются;</li>
                <li>Требовать уточнения, удаления или блокирования данных;</li>
                <li>Отозвать согласие, направив запрос на e-mail Оператора.</li>
            </ul>

            <h2 style={H2}>8. Контакты</h2>
            <p style={P}>
                По вопросам обработки персональных данных:<br/>
                E-mail: <a href="mailto:maksimivankov26@yandex.ru">maksimivankov26@yandex.ru</a><br/>
                Адрес: Краснодарский край, г. Кореновск, ул. Мира 93
            </p>
        </main>
    );
}


const H2 = { marginTop: 28, marginBottom: 10, color: '#0f172a', fontSize: 18, fontWeight: 700 };
const P  = { color: '#475569', fontSize: 15, lineHeight: 1.7, marginBottom: 10 };
const UL = { color: '#475569', fontSize: 15, lineHeight: 1.7, marginBottom: 10, paddingLeft: 22 };
